import {dbComun} from '../bases-datos'

export const ObtenerTodasLasSedes = async () => {
  return Promise.resolve(dbComun.table('Sedes').toArray())
}

export const ObtenerSedePorId = async (id) => {
  return Promise.resolve(dbComun.table('Sedes').get({Id: id}))
}
